import { graphql } from '../../generated';

export const REMOVE_DELIVERY_FROM_PICKLIST = graphql(`
  mutation RemoveDeliveryFromPicklist($deliveryId: ID!) {
    removeDeliveryFromPicklist(input: { deliveryId: $deliveryId }) {
      clientMutationId
    }
  }
`);
